import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@pkg/components/Sections/Profile/Buttons';

import { YAT_PICKER } from '@app/routes/paths';

import { ContentButtons, ContentTitle, Wrapper } from './NoYatsError.style';

export function NoYatsError() {
    const [translate] = useTranslation(['nft_details', 'common']);

    return (
        <Wrapper>
            <ContentTitle>{translate('dashboard:you_dont_have_any_yats_yet')}</ContentTitle>

            <ContentButtons>
                <Button size="large" to={YAT_PICKER}>
                    {translate('dashboard:create_your_first_yat')}
                </Button>
            </ContentButtons>
        </Wrapper>
    );
}
